import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Router from './routes'
import { AuthProvider } from 'contexts/AuthContext'
import { BackdropModalProvider } from './contexts/BackdropContext'
import ThemeProvider from './theme'
import { HelmetProvider } from 'react-helmet-async'
import { ModalPlayer } from './components/ModalPlayer'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { Snackbar } from 'components/Snackbar'
import { GoogleOAuthProvider } from '@react-oauth/google'

export default function App () {
  return (
    <Provider store={store}>
      <Snackbar />
      <HelmetProvider>
        <ThemeProvider>
          <BrowserRouter>
            <BackdropModalProvider>
              <GoogleOAuthProvider clientId={'150152706105-v9q3k2ct25f8vo7qe6cqu1rim48s5u36.apps.googleusercontent.com'}>
                <AuthProvider>
                  <ModalPlayer />
                  <Router />
                </AuthProvider>
              </GoogleOAuthProvider>
            </BackdropModalProvider>
          </BrowserRouter>
        </ThemeProvider>
      </HelmetProvider>
    </Provider>
  )
}
